
<div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'"><mat-spinner style="margin:0 auto; margin-top: 15%;" ></mat-spinner></div>

<div>
    <app-simulacion-jardin [jardin]="jardinSeleccionado" *ngIf="showSimulacion"></app-simulacion-jardin>
</div>
<div *ngIf="!showSimulacion" >
    <div class="row" style="margin-bottom: 90px;">
        <div class="col-sm-4">
            <div class="projects me-2">
                <div class="card">
                    <div class="card-header header-background">
                        <p class="welcome-title">Bienvenida, {{tutor?.nombres}}  {{tutor?.apellidos}}<b></b></p>
                    </div>
        
                    <div class="card-body">
                        
                        <div style="padding: 35px;">
                            <p><b>Considere:</b></p>
                           <br>
                            <p> Al pinchar el botón <b>Simular plataforma</b> accede a una vista especial que le permite visualizar en tiempo real la plataforma de la respectiva Unidad Educativa. </p>
                        </div>
                    </div>
        
                </div>
            </div>
    
            <div class="customers mt-2 me-2">
                <div class="card">
                    <div class="card-body">
                        <div style="padding: 20px 35px;">
                            <div class="row">
                                <div class="col-sm-10">
                                    <p class="titulo-card-azul">Dudas o Consultas</p>
                            
                                    <p style="margin-top: 10px;margin-bottom: 10px;">
                                        Si tiene consultas tanto técnicas como de usabilidad de la plataforma, ingréselas en el siguiente formulario de contacto.
                                    </p>
                                    <textarea class="text-area-consulta" name="consulta" [(ngModel)]="consulta" #introduccion='ngModel'></textarea>
                                    <button type="button" class="btn btn-light btn-send" (click)='enviarMensaje()' > Enviar</button>
                                    <button type="button" class="btn btn-light btn-historial" (click)='abrirModalHistorial()' > Historial</button>
                                </div>
                                <div class="col-sm-2">
                                    <div class="image-title" style="display: inline-block;">
                                        <img src="../../../../../assets/icons/question@2x.png" alt="avatar" class="title-pic" style="width: 110px;" >                  
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="col-sm-8">
            <div class="customers">
                <div class="card">
                    <div class="card-body">
                        <div style="padding: 20px 30px;">
                            <div class="row">
                                <div class="col-sm-12">
                                    <p class="titulo-card-azul">Mis Unidades Educativas</p>
                            
                                    <div class="row mt-2 mb-2"  >
                                        <div class="col-sm-3">
                                            <p class="table-row-title">Unidad Educativa</p>
                                        </div>
                                        <div class="col-sm-2">
                                            <p class="table-row-title">Directora/Encargada</p>
                                        </div>
                                        <div class="col-sm-2">
                                            <p class="table-row-title">Correo</p>
                                        </div>
                                        <div class="col-sm-2">
                                            <p class="table-row-title">Teléfono</p>
                                        </div>
                                        <div class="col-sm-2">
                                            <p class="table-row-title">Acciones</p>
                                        </div>
                                        <div class="col-sm-1">
    
                                           
                                        </div>
                                    
                                    </div>
    
                                    <div *ngFor="let row of jardines; let i = index" style="margin-bottom: 5px;background: #EAEEFB 0% 0% no-repeat padding-box;padding: 10px;">
                                        <div class="row"  >
                                            <div class="col-sm-3">
                                                <p class="table-row-title">{{row.detail.jardin}}</p>
                                            </div>
                                            <div class="col-sm-2">
                                                <p class="table-row-title">{{row.detail.directora}}</p>
                                            </div>
                                            <div class="col-sm-2">
                                                <p class="table-row-title">{{row.detail.correoDirectora}}</p>
                                            </div>
                                            <div class="col-sm-2">
                                                <p class="table-row-title">{{row.detail.telefonoDirectora}}</p>
                                            </div>
                                            <div class="col-sm-2">
                                                <button type="button" class="btn btn-light btn-send" style="background: #597CEE 0% 0% no-repeat padding-box;
                                                border-radius: 10px; height: 38px;
                                                opacity: 1;"  (click)="simular(row.detail)" > Simular Plataforma</button>
                                            </div>
                                            <div class="col-sm-1" style="text-align: right;">
                                                <img src="../../../../../assets/icons/JUNJI__blue-plus_hover.svg" style="width: 38px;cursor: pointer;" *ngIf="row.isCollapsed" (click)="row.isCollapsed = false" [attr.aria-expanded]="!row.isCollapsed">
                                                <img src="../../../../../assets/icons/JUNJI__blue-less_hover.svg" style="width: 38px;cursor: pointer;" *ngIf="!row.isCollapsed" (click)="row.isCollapsed = true" [attr.aria-expanded]="!row.isCollapsed">
                                                
                                            </div>
                                        </div>
                                        <div #collapse="ngbCollapse" [ngbCollapse]="row.isCollapsed" >
                                            <table class="table table-hover mt-3">
                                                <thead>
                                                  <tr>
                                                    <th style="width: 25%" scope="col">Sessión</th>
                                                    <th style="width: 25%" scope="col">Fecha</th>
                                                    <th style="width: 25%" scope="col">Estado</th>
                                                    <th style="width: 25%" scope="col">Acciones</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <tr *ngFor="let tutoria of row.detail.tutorias; let i = index">
                                                    <td><p class="table-row-title">Tutoría {{tutoria.numeroTutoria}}</p></td>
                                                    <td><p class="table-row-title">{{tutoria.fechaInicioTutoria  | date:'dd/MM/yyyy'}}</p></td>
                                                    <td><p class="table-row-title">{{tutoria.estadoTutoria}}</p></td>
                                                    <td>
                                                        <button style="height: 40px;" type="button" *ngIf="tutoria.idEstadoTutoria === 147"  disabled class="btn btn-light btn-send botonCalendario"  > Pendiente Agendar</button>
                                                        <button style="height: 40px;" type="button" *ngIf="tutoria.idEstadoTutoria === 148"  (click)="hacerActa(tutoria,row.detail)" class="btn btn-light btn-send botonCalendario" > Hacer Acta</button>
                                                        <button style="height: 40px;" type="button" *ngIf="tutoria.idEstadoTutoria === 149" disabled class="btn btn-light btn-send botonCalendario"  > Pendiente Aprobación</button>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                            </table>
                                           
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    
    
    
    <ng-template #modalCrearActa let-modal>
        <div class="modal-header" style="padding: 0px 23px;" width="100%" >
            <h5 id="modalTitleUser" class="titulo-card-amarillo" style="  font-size: 22px;  margin: 12px;">Crear Acta Sesión de Acompañamiento Personalizado </h5>
            <button type="button" class="close" (click)="close()" style="background: none;border: none;font-size: xx-large;">
              <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" style="padding: 0px 50px;" width="100%" >
            
            <div class="row">
                <div class="col-sm-12 mt-2">
                    <p style="text-align: left; letter-spacing: 0px; color: #30374B;opacity: 1;">
                        La presente acta respalda la realización de la sesión de Acompañamiento personalizado llevada a cabo por la Unidad educativa <b>{{ modalData?.jardinTutorModel?.jardin  }}</b> como parte de la etapa de Capacitación de la 8ª aplicación del Modelo de Gestión de Calidad de la Educación Parvularia.
                    </p>
                    <p>
                        El acta que se presenta a continuación, sintetiza información relevante de la sesión realizada por la Unidad Educativa: <b>{{ modalData?.jardinTutorModel?.jardin  }}</b> como parte de la 8ª aplicación del Modelo de Gestión de la Calidad de la Educación Parvularia.
                    </p>
                </div>
            </div>
           
            <div style="background: #F5F6FC 0% 0% no-repeat padding-box;padding: 5px;">

            
                <div class="row mt-3" >
                    <div class="col-sm-8 ">
                        <p class="table-row-title">DECLARE EL NÚMERO DE PARTICIPANTES Y SU ROL:</p>
                    </div>
                    <div class="col-sm-4" style="text-align: right;">
                        <p style="display: inline-block;">N° Participantes:</p>
                        <input type="number" class="form-control"  [(ngModel)]="modalData.datosActa.numeroParticipantes" style="padding: 6px 12px;width: 70px;display: inline-block;margin-left: 10px;"  #numeroParticipantes disabled>
                    </div>
                </div>
            
                <div class="row mt-3" >
                    <div class="col-sm-5 ">
                        <p style="display: inline-block;">Participante</p>
                        <input type="text" #participante class="form-control" style="width: 200px;display: inline-block;margin-left: 10px;" >
                    </div>
                    <div class="col-sm-5 ">
                        <p style="display: inline-block;">Rol</p>
                        <input type="text" #rol class="form-control" style="width: 200px;display: inline-block;margin-left: 10px;" >
                    </div>
                    <div class="col-sm-2 ">
                        <img (click)="agregarParticipante(participante,rol,modalData.datosActa.participantes,numeroParticipantes,modalData.datosActa)" style="width: 35px;cursor: pointer;" src="../../../../../assets/icons/JUNJI__blue-plus_hover.svg" >
                    </div>
                </div>

                <div class="row mt-3" >
                    <div class="col-sm-12 ">
                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th scope="col">Participante</th>
                                <th scope="col">Rol</th>   
                                <th scope="col" style="width: 50px;">Acción</th>      
                            </tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let participante of modalData.datosActa.participantes">
                                    <td>{{participante.participante}}</td>
                                    <td>{{participante.rol}}</td>
                                    <td> 
                                        <img (click)="eliminarParticipante(participante,modalData.datosActa.participantes,numeroParticipantes,modalData.datosActa)" style="width: 30px;cursor: pointer;" src="../../../../../assets/icons/JUNJI__blue-less_hover.svg" >
                                    </td>
                                </tr>
                            
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row mt-3" >
                <div class="col-sm-4">
                    <p class="table-row-title">Número de Sessión</p>
                </div> 
                <div class="col-sm-8">
                    <p class="table-row-title">Sessión {{ modalData?.jardinTutoria?.numeroTutoria  }}</p>
                </div>          
            </div>
    
            <div class="row mt-3" >
                <div class="col-sm-4">
                    <p class="table-row-title">Fecha</p>
                </div> 
                <div class="col-sm-8">
                    <div class="input-group">
                        <input class="form-control" placeholder="yyyy-mm-dd" style="padding: 6px 12px;" [(ngModel)]="modalData.modelDate" name="dp" ngbDatepicker #d="ngbDatepicker">
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" style="width: 40px;padding: 6px 12px;" type="button">
                                <i class="fas fa-calendar-alt"></i>
                            </button>
                        </div>
                    </div>
                       
                </div>          
            </div>
    
            <div class="row mt-3" >
                <div class="col-sm-6">
                    <p class="table-row-title"> Hora Inicio</p>
                    <ngb-timepicker [(ngModel)]="modalData.timeInit"></ngb-timepicker>
                </div> 
                <div class="col-sm-6">
                    <p class="table-row-title"> Hora Fin</p>
                    <ngb-timepicker [(ngModel)]="modalData.timeEnd"></ngb-timepicker>
                </div>          
            </div>
            <div class="row mt-3" >
                <div class="col-sm-12">
                    <p class="table-row-title"> Comentario</p>
                    <textarea class="text-area-comentario" name="comentario" [(ngModel)]="modalData.datosActa.comentarioTutor" #comentario='ngModel' style="background: #F5F6FC 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;border: none;margin-bottom: 10px;width: 100%; height: 165px;padding: 10px;"></textarea>
                </div> 
                     
            </div>
            
            <div class="errores" *ngIf="erores != ''" >
                <p class="table-row-title " style="color: #D8000C;">{{ erores }}</p>
            </div>
    
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-send botonCalendario" style="margin: 5px;font-size: 16px;height: 45px;" (click)="enviar(modalData)">Enviar</button>
            <button type="button" class="btn btn-send botonCalendario" style="margin: 5px;font-size: 16px;height: 45px;background-color: #EE366D;" data-bs-dismiss="modal" (click)="close()">Cerrar</button>
          </div>
    </ng-template>



    <ng-template #modalHistorial let-modal>
        <div class="modal-header" style="padding: 0px 23px;" width="100%" >
            <h5 id="modalTitleUser" class="titulo-card-amarillo" style="    margin: 25px">Historial de consultas</h5>
            <button type="button" class="close" (click)="close()" style="background: none;border: none;font-size: xx-large;">
              <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" style="padding: 0px 50px;" width="100%" >
    
            <p style="margin-top: 20px;margin-bottom: 10px;">
                Revise aquí las consultas que ha realizado previamente.
            </p>
            
        </div>
        <div class="row" style="margin-left: 30px; margin-right: 30px; margin-bottom: 5px;padding: 10px;">
            <div class="col-sm-2">
                <p class="table-row-title" style="text-align: left; font: normal normal bold 16px/28px Hind Siliguri; letter-spacing: 0px;
                color: #4C4D55;
                opacity: 1;">Fecha</p>
            </div>
            <div class="col-sm-8">
                <p class="table-row-title" style="text-align: left; font: normal normal bold 16px/28px Hind Siliguri; letter-spacing: 0px;
                color: #4C4D55;
                opacity: 1;">Consulta</p>
            </div>
            <div class="col-sm-2">
                
            </div>
        </div>
    
        <div *ngFor="let row of rows; let i = index" style="margin-left: 30px; margin-right: 30px; margin-bottom: 5px;background: #EAEEFB 0% 0% no-repeat padding-box;padding: 10px;">
            <div class="row"  >
                <div class="col-sm-2">
                    <p class="table-row-title">{{row.detail.fechaIngreso | date:'dd/MM/yyyy'}}</p>
                </div>
                <div class="col-sm-8">
                    <p class="table-row-title">{{row.detail.consulta}}</p>
                </div>
                <div class="col-sm-2">
                    <button type="button" class="btn btn-light btn-send" style="background: #597CEE 0% 0% no-repeat padding-box;width: 100px;
                    border-radius: 10px;
                    opacity: 1;"  (click)="row.isCollapsed = !row.isCollapsed" [attr.aria-expanded]="!row.isCollapsed"> ver</button>
                </div>
            </div>
            <div #collapse="ngbCollapse" [ngbCollapse]="row.isCollapsed" >
                
                   <p>{{row.detail.respuesta}}</p>
                
            </div>
        </div>
        
        <button class="btn-cancelar"  (click)="close()" style="border: none;height: 50px;margin: 10px;">Volver  
        </button>
    </ng-template>

</div>
